<template>
	<div class="resetpassword">
		<div class="registerbox">
			<div class="registerbox_FF">
				<div class="submit1" v-if="resettype==1">
					<div class="title">重置密码</div>
					<div class="item">请先输入您的学号：</div>
					<div class="item2">
						<input type="text" v-model.lazy="userno" placeholder="请输入您的学号" />
					</div>
					<div class="itembtn tt">
						<button @click="submit1">下一步</button>
						<a href="javascript:void(0);" @click="backlogin">返回登录</a>
					</div>
				</div>
				<div class="submit2" v-else>
					<div class="title">重置密码</div>
					<div class="item">请回答安全问题：</div>
					<div class="item_message">
						{{question}}
					</div>
					<div class="item2">
						<input type="text" v-model.lazy="answer2" placeholder="请输入安全问题答案" />
					</div>
					<div class="item2 password2">
						<input type="password" v-model.lazy="password1" placeholder="请输密码" />
						<img src="../../assets/images/yj.png" />
					</div>
					<div class="item2 password2">
						<input type="password" v-model.lazy="password2" placeholder="请确认密码" />
						<img src="../../assets/images/yj.png" />
					</div>
					<div class="itembtn">
						<button @click="submitpass">确认重置</button>
						<a href="javascript:void(0);" @click="backlogin">返回登录</a>
					</div>
				</div>
			</div>
		</div>
		<popup ref="popup" :types="popuptype" :message="submessage"></popup>
	</div>
</template>

<script>
	import axios from 'axios'
	import popup from '../popups/popup.vue'
	export default {
		name: 'Resetpassword',
		components:{
			popup
		},
		data() {
			return {
				resettype: this.$route.params.type == undefined ? 1 : this.$route.params.type,
				userno: null,
				question: null, //安全问题
				answer: null, //问题答案
				password1: null,
				password2: null,
				answer2: null,
				submessage: null,
				popuptype:'success'
			}
		},
		methods: {
			backlogin() {
				this.$router.back()
			},
			submit1() {
				if (this.userno == null || this.userno == '') {
					this.submessage = "请输入您的学号"
					this.popuptype = 'warning'
					this.$refs.popup.popupshow()
				} else {
					this.getUserListByID()
				}
			},
			getUserListByID() {
				axios({
					method: 'get',
					url: this.$api.commonUrl + 'student/number/' + this.userno,
					responseType: "json"
				}).then(res => {
					if (res.data.code == '200') {
						this.resettype = 2
						this.userno = res.data.data.userAuth.identifier
						this.answer = res.data.data.answer
						this.question = res.data.data.questionName
					} else {
						this.submessage = res.data.message
						this.popuptype = 'error'
						this.$refs.popup.popupshow()
					}
				}).catch(err => {
					console.log("insert", err)
				})
			},
			submitpass() {
				if(this.changesubmit2()){
					axios({
						method: 'post',
						url: this.$api.commonUrl + 'student/pwd',
						data:{
							identifier: this.userno,
							passWord: this.password1
						},
						responseType: "json"
					}).then(res => {
						if (res.data.code == '200') {
							
							this.submessage = "密码重置成功！"
							this.popuptype = 'success'
							this.$refs.popup.popupshow()
							setTimeout(()=>{
								this.$router.back()
							},1000)
						}else{
							alert(res.data.message)
						}
					}).catch(err =>{
						console.log("insert", err)
					})
				}else{
					this.$refs.popup.popupshow()
				}
			},
			changesubmit2() {
				let issub = false
				if (this.answer2 == null || this.answer2 == '') {
					this.submessage = '请输入安全问题答案'
					this.popuptype = 'warning'
					issub = false
				} else if (this.password1 == null || this.password1 == '') {
					this.submessage = '请输入您的新密码'
					this.popuptype = 'warning'
					issub = false
				} else if (this.password2 == null || this.password2 == '') {
					this.submessage = '请确认您的新密码'
					this.popuptype = 'warning'
					issub = false
				} else if (this.password1 != this.password2) {
					this.submessage = '两次密码不一致'
					this.popuptype = 'error'
					issub = false
				} else if (this.answer != this.answer2) {
					this.submessage = '您输入的答案不正确'
					this.popuptype = 'error'
					issub = false
				} else {
					this.submessage = null
					issub = true
				}
				return issub
			}
		}
	}
</script>
<style scoped>
	@import url("../../assets/css/style.css");

	.resetpassword {
		position: absolute;
		z-index: 2;
		width: 100%;
		height: 100%;
	}

	.resetpassword .registerbox {
		width: 32rem;
		height: 32rem;
		background: rgba(255, 255, 255, 0.5);
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		margin: auto;
	}

	.resetpassword .registerbox_FF {
		position: absolute;
		top: 0.5rem;
		left: 0.5rem;
		right: 0.5rem;
		bottom: 0.5rem;
		background: #FFFFFF;
		z-index: 2;
	}

	.resetpassword .title {
		font-size: 1.6rem;
		line-height: 2rem;
		height: 2rem;
		text-align: center;
		color: #a73a29;
		padding-top: 2rem;
		padding-bottom: 0.5rem;
	}

	.resetpassword .item {
		width: calc(100% - 4rem);
		height: 2rem;
		margin-left: 2rem;
		margin-top: 1.5rem;
		font-size: 1.2rem;
		font-weight: bold;
		color: #34201d;
		line-height: 2rem;
	}

	.resetpassword .item_message {
		width: calc(100% - 4rem);
		height: 2rem;
		margin-left: 2rem;
		font-size: 1rem;
		color: #34201d;
		line-height: 1.5rem;
	}

	.resetpassword .item2 {
		width: calc(100% - 4rem);
		height: 2.8rem;
		margin-left: 2rem;
		margin-top: 1.5rem;
		border: 2px solid #a73a29;
	}

	.resetpassword .item2 input {
		width: calc(100% - 1.2rem);
		border: none;
		height: 2rem;
		margin: 0.2rem;
		padding: 0.2rem 0.4rem;
		line-height: 2rem;
		font-size: 1rem;
	}

	.resetpassword .password2 {
		position: relative;
	}

	.resetpassword .password2 input {
		width: calc(100% - 3.2rem);
	}

	.resetpassword .password2 img {
		width: 2rem;
		height: 2rem;
		position: absolute;
		margin: auto;
		top: 0;
		bottom: 0;
	}

	.resetpassword .itembtn {
		width: calc(100% - 4rem);
		height: auto;
		margin-left: 2rem;
		margin-top: 1.5rem;
		padding: 2px;
	}

	.resetpassword .itembtn button {
		width: 18rem;
		height: 3rem;
		border: none;
		background: #a73a29;
		color: #FFFFFF;
		font-size: 1rem;
	}

	.resetpassword .itembtn a {
		float: right;
		line-height: 3rem;
		font-size: 1rem;
		color: #3e392e;
		padding-right: 1rem;
	}

	.resetpassword .tt {
		margin-top: 13rem;
	}

	@media screen and (max-width: 1680px) {
		html {
			font-size: 14px;
		}
	}

	@media screen and (max-width: 1600px) {
		html {
			font-size: 13px;
		}
	}

	@media screen and (max-width: 1440px) {
		html {
			font-size: 12px;
		}
	}

	@media screen and (max-width: 1400px) {
		html {
			font-size: 12px;
		}
	}

	@media screen and (max-width: 1366px) {
		html {
			font-size: 10px;
		}
	}

	@media screen and (max-width: 1360px) {
		html {
			font-size: 10px;
		}
	}

	@media screen and (max-width: 1280px) {
		html {
			font-size: 11px;
		}
	}

	@media screen and (max-width: 1152px) {
		html {
			font-size: 10px;
		}
	}

	@media screen and (max-width: 1024px) {
		html {
			font-size: 9px;
		}
	}

	@media screen and (max-width: 800px) {
		html {
			font-size: 8px;
		}
	}
</style>
